module.exports = __webpack_public_path__ + "img/a8_03.00353510.jpg";